import { LOADING_STATES } from '@/constants';
import { i18n_t as $t } from '@/utils/i18n';
import { segmentDeletedTitle, segmentDeletedSubtext } from '@/utils/segment-deleted-error.utils';

const { LOADING, REJECTED, EMPTY } = LOADING_STATES;

export const WIDGET_MESSAGE_SIZE = Object.freeze({
    MINI: 'mini',
    SM: 'sm',
    LG: 'lg',
});

export const messageFactory = (text, subtext, status, icon, image) =>
    Object.freeze({
        text,
        ...(subtext && { subtext }),
        status,
        icon,
        image,
    });

export const segmentDeletedMessage = () => messageFactory(segmentDeletedTitle(), segmentDeletedSubtext(), REJECTED);

export const widgetMessagesFactory = (customMessages = {}) =>
    Object.freeze({
        get [LOADING] () {
            return messageFactory($t('common.Loading...'));
        },
        get [REJECTED] () {
            return messageFactory(
                $t('widgetMessageHelpers.There was an error loading this chart.'),
                $t('widgetMessageHelpers.Try reloading the page, or contact support if the issue persists.'),
                REJECTED,
            );
        },
        get [EMPTY] () {
            return messageFactory(
                $t('widgetMessageHelpers.No data available.'),
                $t('widgetMessageHelpers.Data will appear as usage occurs. Consider adjusting any applied filters.'),
            );
        },
        ...customMessages,
    });
